<template>
  <div class="datepicker-months">
    <table class="table-condensed">
      <thead>
        <tr>
          <!-- <th class="prev" @click.prevent="previous">
            <span class="glyphicon glyphicon-chevron-left" title="Previous Year"></span>
          </th>-->
          <th class="picker-switch" colspan="5" title="Select Year" @click="showYear" v-show="showYearHeader">
            {{ year }}
          </th>
          <!-- <th class="next" @click.prevent="next">
            <span class="glyphicon glyphicon-chevron-right" title="Next Year"></span>
          </th>-->
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colspan="7">
            <span
              v-for="month in months"
              :key="month"
              @click="selectMonth(month)"
              class="year"
              :class="[activeMonthClass(month)]"
              >{{ month }}</span
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MonthPicker',
  props: {
    currentDate: {
      default: () => moment()
    },
    format: {
      type: String,
      default: 'MMMM',
      validator: function(value) {
        return ['MMMM', 'MMM', 'MM', 'M'].indexOf(value.toUpperCase()) !== -1
      }
    },
    showYearHeader: Boolean
  },
  computed: {
    year() {
      return this.currentDate.format('YYYY')
    },
    months() {
      return moment.monthsShort()
    },
    activeMonthClass: vm => selectedMonth => {
      return {
        active: selectedMonth.toString() === vm.currentDate.format('MMM')
      }
    }
  },
  methods: {
    previous() {
      this.selectYear(parseInt(this.year) - 1)
    },
    next() {
      this.selectYear(parseInt(this.year) + 1)
    },
    selectMonth(selectedMonth) {
      this.$emit(
        'select-month',
        moment()
          .month(selectedMonth)
          .format(this.format)
      )
      this.$emit('change-picker', 'day')
    },
    selectYear(selectedYear) {
      this.$emit('select-year', selectedYear.toString())
    },
    showYear() {
      this.$emit('change-picker', 'year')
    }
  }
}
</script>
